import script from "./carritoGST.vue?vue&type=script&setup=true&lang=js"
export * from "./carritoGST.vue?vue&type=script&setup=true&lang=js"

import "./carritoGST.vue?vue&type=style&index=0&id=266e41b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-266e41b4"]])

export default __exports__